// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"3987e345","787":"30e837d5","938":"5a0740aa"}[chunkId] + ".chunk.js";
};